'use client';

import { DataGridPremium } from '@mui/x-data-grid-premium';
import { useQuery } from '@parkchirp/api-client';
import React, { FC, useState } from 'react';

import { GET_LEASE_UTILIZATION } from '../../../queries';
import { SetShowDialog } from '../../../types';
import { LeasingRight } from '../../../types/leases';
import { getMustTakesColumns } from './mustTakesColumns';

type MustTakesTableProps = {
	leasingRight: LeasingRight;
	setShowDialog: SetShowDialog;
	getUrlToSubscriptionPage: (...x: any) => string;
};

export const MustTakesTable: FC<MustTakesTableProps> = ({ leasingRight, setShowDialog, getUrlToSubscriptionPage }) => {
	const [rows, setRows] = useState<any[]>([]);

	const { loading } = useQuery(GET_LEASE_UTILIZATION, {
		fetchPolicy: 'network-only',
		variables: {
			leasingRightId: leasingRight.id,
			subscriptionId: leasingRight.subscriptionId,
		},
		context: { apiVersion: 'v2' },
		onCompleted: (response) => {
			setRows(response.getLeaseUtilization?.countsAndRates);
		},
	});
	const columns = getMustTakesColumns(setShowDialog, getUrlToSubscriptionPage, leasingRight.facilityId);

	return <DataGridPremium autoHeight disableRowSelectionOnClick rows={rows} columns={columns} loading={loading} />;
};
